import {AuthError, AuthTokens, ProblemDetails} from '../../types';
import baseUrl from '../baseUrl';

const refreshAuthentication = async (
    token: string
): Promise<AuthTokens | ProblemDetails | AuthError> => {
    const response = await fetch(`${baseUrl}/api/auth/refresh-authentication`, {
        method: 'POST',
        body: JSON.stringify({token}),
        headers: {
            'Content-Type': 'application/json'
        }
    });

    return response.json();
};

export default refreshAuthentication;
